import React, { useEffect, useState, lazy } from 'react';
import { LeadForm } from './LeadForm';
import { PhoneIcon, StarIcon, ShieldCheckIcon, ClockIcon, DollarSignIcon, X } from 'lucide-react';
export function ResidentialLanding() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);
  return <div className="min-h-screen bg-white font-sans text-[#1B2A3D] pb-20 md:pb-0" data-id="element-42">
      {/* Urgency Bar */}
      <div className="bg-[#0C8CE9] text-white text-sm md:text-base font-bold py-2 px-4 text-center" data-id="element-43">
        ⚡ LIMITED SPOTS — Only 10 Homeowners Accepted Per Week
      </div>

      {/* Header */}
      <header className="bg-[#0C8CE9] sticky top-0 z-40" data-id="element-44">
        <div className="max-w-6xl mx-auto px-4 py-2 flex justify-between items-center" data-id="element-45">
          <img src="https://cdn.magicpatterns.com/uploads/12oFyLJ3njFiy4SGXXx26A/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-8 md:h-10 w-auto" data-id="element-46" />
          <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white font-bold text-sm md:text-base py-1.5 px-4 rounded-full transition-colors" data-id="element-47">
            <PhoneIcon className="w-4 h-4" data-id="element-48" />
            <span data-id="element-49">(480) 599-8442</span>
          </button>
        </div>
      </header>

      <main data-id="element-50">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 px-4 overflow-hidden" data-id="element-51">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/r5tz6Szc1jF7KBZoDBgkYV/residential_5.webp)'
        }} data-id="element-52" />
          <div className="absolute inset-0 bg-white/80" data-id="element-53" />
          <div className="relative max-w-4xl mx-auto text-center" data-id="element-54">
            <p className="text-[#0C8CE9] font-bold tracking-wider uppercase text-sm md:text-base mb-4" data-id="element-55">
              Residential Power Washing — Phoenix Valley
            </p>
            <h1 className="text-4xl md:text-6xl font-extrabold text-[#1B2A3D] leading-tight mb-6" data-id="element-56">
              Driveways. Patios. Walls. <br className="hidden md:block" data-id="element-57" />
              <span className="text-[#0C8CE9]" data-id="element-58">
                We Make Your Home Look Brand New.
              </span>
            </h1>
            <p className="text-lg md:text-xl text-[#1B2A3D] mb-8 max-w-2xl mx-auto opacity-90" data-id="element-59">
              Professional driveway cleaning, house washing, patio restoration,
              fence brightening & more. 300+ Phoenix homes transformed. 150+
              five-star reviews.
            </p>

            <button onClick={() => setIsModalOpen(true)} className="bg-[#0C8CE9] hover:bg-[#0a7bc0] text-white font-bold text-xl py-4 px-10 rounded-full shadow-lg transform transition hover:scale-105 mb-8" data-id="element-60">
              Get My Free Quote &rarr;
            </button>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm md:text-base font-semibold text-[#1B2A3D]" data-id="element-61">
              <div className="flex items-center gap-1" data-id="element-62">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F5A623] fill-current" data-id="element-63" />)}
                <span className="ml-2" data-id="element-64">150+ Five-Star Google Reviews</span>
              </div>
              <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-[#1B2A3D] opacity-30" data-id="element-65"></div>
              <div className="flex items-center gap-2" data-id="element-66">
                <ShieldCheckIcon className="w-5 h-5 text-[#0C8CE9]" data-id="element-67" />
                <span data-id="element-68">Licensed • Bonded • Insured</span>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Strip */}
        <section className="bg-[#1B2A3D] text-white py-12 px-4" data-id="element-69">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-70">
            <div className="flex flex-col items-center" data-id="element-71">
              <DollarSignIcon className="w-12 h-12 text-[#0C8CE9] mb-4" data-id="element-72" />
              <h3 className="text-xl font-bold mb-2" data-id="element-73">Protect Your Home</h3>
              <p className="text-gray-300" data-id="element-74">
                Regular cleaning prevents mold, algae & costly damage to your
                driveway, walls & roof.
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-75">
              <ClockIcon className="w-12 h-12 text-[#0C8CE9] mb-4" data-id="element-76" />
              <h3 className="text-xl font-bold mb-2" data-id="element-77">
                Done in Hours, Not Days
              </h3>
              <p className="text-gray-300" data-id="element-78">
                Most residential jobs completed same-day. Driveways, patios,
                house wash — we handle it all.
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-79">
              <ShieldCheckIcon className="w-12 h-12 text-[#0C8CE9] mb-4" data-id="element-80" />
              <h3 className="text-xl font-bold mb-2" data-id="element-81">Licensed & Insured</h3>
              <p className="text-gray-300" data-id="element-82">
                Fully licensed, bonded & insured. Your home is in safe,
                professional hands.
              </p>
            </div>
          </div>
        </section>

        {/* See Our Work Section (Image Heavy) */}
        <section className="py-16 md:py-24 px-4 bg-white" data-id="element-83">
          <div className="max-w-6xl mx-auto" data-id="element-84">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1B2A3D] mb-4" data-id="element-85">
              Real Results for Phoenix Homeowners
            </h2>
            <p className="text-center text-[#1B2A3D] opacity-80 mb-12 max-w-2xl mx-auto" data-id="element-86">
              Driveways, walls, patios, trash cans, windows — see what
              professional power washing does for homes just like yours.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/2vkqu9ZysdWKXosKFkHhbi/residential_ba_1.webp" alt="Residential wall cleaning before and after" loading="lazy" className="w-full h-auto rounded-xl shadow-lg object-cover" data-id="element-88" />
              <img src="https://cdn.magicpatterns.com/uploads/urww9qvxPUY4yJpaKy5WbK/residential_ba_2.webp" alt="Residential driveway cleaning before and after" loading="lazy" className="w-full h-auto rounded-xl shadow-lg object-cover" data-id="element-89" />
              <img src="https://cdn.magicpatterns.com/uploads/qx7Ab8frZM9wpmYdg4kKCK/residential_ba_3.webp" alt="Home driveway and front yard cleaning before and after" loading="lazy" className="w-full h-auto rounded-xl shadow-lg object-cover" data-id="element-90" />

              {/* Trash Cans Before/After side-by-side */}
              <div className="grid grid-cols-2 gap-4" data-id="element-91">
                <div className="flex flex-col h-full" data-id="element-92">
                  <span className="bg-gray-800 text-white text-xs font-bold px-2 py-2 rounded-t-xl text-center uppercase tracking-wider" data-id="element-93">
                    Before
                  </span>
                  <img src="https://cdn.magicpatterns.com/uploads/da5tLQnLtNX23Yx2qaV9yG/residential_before_4.webp" alt="Residential trash can before cleaning" loading="lazy" className="w-full h-full object-cover rounded-b-xl shadow-lg min-h-[200px]" data-id="element-94" />
                </div>
                <div className="flex flex-col h-full" data-id="element-95">
                  <span className="bg-[#0C8CE9] text-white text-xs font-bold px-2 py-2 rounded-t-xl text-center uppercase tracking-wider" data-id="element-96">
                    After
                  </span>
                  <img src="https://cdn.magicpatterns.com/uploads/9jh18npWJs5dU1gtvhyp8A/residential_after_4.webp" alt="Residential trash can after cleaning" loading="lazy" className="w-full h-full object-cover rounded-b-xl shadow-lg min-h-[200px]" data-id="element-97" />
                </div>
              </div>
            </div>

            <div className="text-center mt-16" data-id="element-98">
              <button onClick={() => setIsModalOpen(true)} className="bg-transparent border-2 border-[#0C8CE9] text-[#0C8CE9] hover:bg-[#0C8CE9] hover:text-white font-bold text-xl py-4 px-10 rounded-full transition-colors shadow-sm" data-id="element-99">
                Get Your Home Looking Like This
              </button>
            </div>
          </div>
        </section>

        {/* Social Proof */}
        <section className="py-16 md:py-24 px-4 bg-[#E8F4FD]" data-id="element-100">
          <div className="max-w-6xl mx-auto" data-id="element-101">
            <div className="text-center mb-12" data-id="element-102">
              <div className="flex justify-center gap-1 mb-4" data-id="element-103">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 text-[#F5A623] fill-current" data-id="element-104" />)}
              </div>
              <h2 className="text-3xl font-bold text-[#1B2A3D]" data-id="element-105">
                Rated 5.0 on Google
              </h2>
              <p className="text-[#1B2A3D] opacity-80 mt-2" data-id="element-106">
                Based on 180+ local homeowner reviews
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-107">
              {[{
              name: 'Sarah M.',
              loc: 'Scottsdale, AZ',
              text: 'Blue Cactus made our 15-year-old driveway look brand new again! The team was on time, professional, and very respectful of our property.'
            }, {
              name: 'David L.',
              loc: 'Phoenix, AZ',
              text: 'Highly recommend their house washing service. They removed years of dust and grime without damaging our stucco. Worth every penny.'
            }, {
              name: 'Jessica T.',
              loc: 'Mesa, AZ',
              text: 'Fast, affordable, and incredible results on our back patio and pool deck just in time for summer. Will definitely use them again next year!'
            }].map((review, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-sm relative" data-id="element-108">
                  <div className="flex text-[#F5A623] mb-4" data-id="element-109">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-110" />)}
                  </div>
                  <p className="text-[#1B2A3D] italic mb-6" data-id="element-111">"{review.text}"</p>
                  <div className="font-bold text-[#1B2A3D]" data-id="element-112">{review.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-113">{review.loc}</div>
                </div>)}
            </div>

            <div className="text-center mt-12" data-id="element-114">
              <button onClick={() => setIsModalOpen(true)} className="bg-[#0C8CE9] hover:bg-[#0a7bc0] text-white font-bold text-xl py-4 px-10 rounded-full shadow-lg transform transition hover:scale-105" data-id="element-115">
                Join 300+ Happy Homeowners &rarr;
              </button>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#1B2A3D] text-white py-12 px-4 text-center" data-id="element-116">
        <div className="max-w-4xl mx-auto" data-id="element-117">
          <div className="flex flex-col items-center justify-center mb-6" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/12oFyLJ3njFiy4SGXXx26A/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-12 w-auto" data-id="element-119" />
          </div>
          <p className="text-xl font-bold mb-4" data-id="element-120">(480) 599-8442</p>
          <p className="text-gray-400 mb-8" data-id="element-121">Licensed • Bonded • Insured</p>
          <p className="text-sm text-gray-500" data-id="element-122">
            &copy; {new Date().getFullYear()} Blue Cactus Power Washing. All
            rights reserved.
          </p>
        </div>
      </footer>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-white p-4 shadow-[0_-10px_15px_-3px_rgba(0,0,0,0.1)] md:hidden flex justify-between items-center z-50 border-t border-gray-100" data-id="element-123">
        <a href="tel:4805998442" className="flex flex-col items-center justify-center w-1/2 border-r border-gray-200 text-[#1B2A3D]" data-id="element-124">
          <PhoneIcon className="w-5 h-5 text-[#0C8CE9] mb-1" data-id="element-125" />
          <span className="text-xs font-bold" data-id="element-126">Call Us</span>
        </a>
        <button onClick={() => setIsModalOpen(true)} className="w-1/2 text-center text-[#0C8CE9] font-bold text-sm" data-id="element-127">
          Get Quote
        </button>
      </div>

      {/* Modal Overlay */}
      {isModalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#1B2A3D]/80 backdrop-blur-sm overflow-y-auto" data-id="element-128">
          <div className="relative w-full max-w-xl my-8 mt-16" data-id="element-129">
            <button onClick={() => setIsModalOpen(false)} className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors flex items-center gap-2" data-id="element-130">
              <span className="font-bold" data-id="element-131">Close</span>
              <X className="w-8 h-8" data-id="element-132" />
            </button>
            <LeadForm variant="residential" data-id="element-133" />
          </div>
        </div>}
    </div>;
}